import {
  Component, EventEmitter, Input, Output
} from '@angular/core';

import { PopoverSizeTypes } from 'models/layout-mod.model';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})
export class PopoverComponent {
  @Input() text = '';

  @Input() link = '';

  @Input() iconName = '';

  @Input() showPopover = true;

  @Input() size: PopoverSizeTypes = 'base';

  @Output() linkClicked = new EventEmitter();

  @Output() popoverClosed = new EventEmitter();

  constructor() { }

  closePopover(): void {
    this.showPopover = false;
    this.popoverClosed.emit();
  }

  onLinkClicked(): void {
    this.linkClicked.emit();
  }

  openPopover(): void {
    this.showPopover = true;
  }
}
